import React from "react";

import SharedEmptyState from "../EmptyState";

/**
 * EmptyState - Displayed when no standings exist
 * Matches Figma design exactly with podium/team cards and organic blob background
 */
const EmptyState = () => {
  return (
    <SharedEmptyState
      illustration={<StandingsIllustration />}
      heading="There have been no events in the competition so far"
      description="As soon as something happens, all the details will be displayed here"
      className="pt-6"
    />
  );
};

/**
 * Blob illustration with podium card placeholders (from Figma)
 */
const StandingsIllustration = () => {
  const scale = 0.75;

  const TeamAvatar = ({ left, top }) => (
    <div
      className="absolute flex flex-col items-center justify-center"
      style={{
        left: `${left * scale}px`,
        top: `${top * scale}px`,
        width: `${88.68 * scale}px`,
        gap: `${6.905 * scale}px`,
      }}
    >
      <div
        className="rounded-full"
        style={{
          width: `${38.006 * scale}px`,
          height: `${38.006 * scale}px`,
          background: "#E5E5D6",
        }}
      />
      <div
        className="flex flex-col items-center justify-center w-full"
        style={{ gap: `${6.905 * scale}px` }}
      >
        <div
          style={{
            width: `${36.245 * scale}px`,
            height: `${6.796 * scale}px`,
            background: "#4C565D",
            borderRadius: "999px",
          }}
        />
        <div
          style={{
            width: `${77.952 * scale}px`,
            height: `${6.796 * scale}px`,
            background: "#E5E5D6",
            borderRadius: "999px",
          }}
        />
      </div>
    </div>
  );

  return (
    <div
      className="relative"
      style={{
        width: `${546.922 * scale}px`,
        height: `${424.345 * scale}px`,
      }}
    >
      {/* Background blob shape */}
      <svg
        className="absolute inset-0"
        width={546.922 * scale}
        height={424.345 * scale}
        viewBox="0 0 548 422"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
        style={{
          transform: "rotate(-1.615deg)",
          transformOrigin: "center",
        }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M299.223 10.2209C357.307 14.3187 416.214 16.415 461.128 45.5826C509.255 76.8366 543.06 121.389 546.749 170.966C550.562 222.208 519.929 269.019 480.83 310.342C435.174 358.594 385.956 413.937 310.784 420.352C232.808 427.007 165.114 384.639 108.652 342.103C52.3801 299.709 3.2525 248.308 0.205792 186.372C-2.88233 123.595 28.8352 57.2701 92.7872 19.5959C150.664 -14.4997 227.988 5.19517 299.223 10.2209Z"
          fill="#081725"
        />
      </svg>

      {/* Team cards and avatars */}
      <div
        className="absolute"
        style={{
          width: `${571.35 * scale}px`,
          height: `${149.546 * scale}px`,
          left: `calc(50% - ${285.675 * scale}px)`,
          top: `calc(50% - ${74.773 * scale}px)`,
        }}
      >
        {/* Center card - tallest */}
        <div
          className="absolute"
          style={{
            left: `${194.16 * scale}px`,
            top: `${78.29 * scale}px`,
            width: `${184.08 * scale}px`,
            height: `${71.257 * scale}px`,
            background: "#B2B5AD",
            borderRadius: `${8.137 * scale}px`,
          }}
        />
        {/* Right card */}
        <div
          className="absolute"
          style={{
            left: `${387.27 * scale}px`,
            top: `${120.04 * scale}px`,
            width: `${184.08 * scale}px`,
            height: `${23.751 * scale}px`,
            background: "#4C565D",
            borderRadius: `${8.137 * scale}px`,
          }}
        />
        {/* Left card */}
        <div
          className="absolute"
          style={{
            left: 0,
            top: `${113.78 * scale}px`,
            width: `${184.08 * scale}px`,
            height: `${35.627 * scale}px`,
            background: "#7F8585",
            borderRadius: `${8.137 * scale}px`,
          }}
        />

        <TeamAvatar left={242.17} top={0} />
        <TeamAvatar left={48.02} top={35.49} />
        <TeamAvatar left={435.29} top={41.75} />
      </div>
    </div>
  );
};

export default EmptyState;
